import { css } from '@emotion/react'
import Footer from '../../components/Footer'
import Header from '../../components/Header'

export type NetworkErrorProps = {
  isError: boolean
}

function NetworkError({ isError }: NetworkErrorProps) {
  return (
    <div className="wrap error_wrap" style={isError ? { display: 'block' } : { display: 'none' }}>
      <Header classNameString="header" />
      <div className="container">
        <div className="error_box">
          <div className="img-error type-connection"></div>
          <div className="error-txtbtn">
            <p className="txt">
              Wi-Fi 설정이 필요해!
              <br />
              현재 연결이 되어 있지 않거나
              <br />
              연결 상태가 불안정해.
              <br />
              다시 설정해 줄래?
            </p>
            <button
              className="btn-error"
              onClick={() => {
                if (isError) return
                window.location.reload()
              }}
            >
              다시 시도
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default NetworkError
